
import {QueryCommand } from 'goingutils';

export default {
    name: "common-mixins",
    data: function () {
        return {
            loadD3Flag:false,
            svgEye:false,
            svgCtlObj:null,
            treeSvgCtl:null,
            pageTabObj: null,
            showLevel: 3,
            sizeLabel: "100%",
            showLevelItem: {
                id: "showLevel",
                editorType: "staticDrop",
                label: "显示层级",
                defVal: "3",
                items: [
                    { id: "1", label: "1" },
                    { id: "2", label: "2" },
                    { id: "3", label: "3" },
                    { id: "4", label: "4" }
                ]
            },
        };
    },
    computed: {},
    props: {
        data:{default:()=>{
            return null;
        },type:Object}
    },
    methods: {
        nodeClick(node){
            this.$emit("nodeClick",{node:node.data});
        },
        selDrop(){
            if(this.svgCtlObj){
                this.svgCtlObj.destruction();
                this.initTreeCtl();
            }
        },
        changeSizeLabel(sizeLabel){
            this.sizeLabel=parseFloat((parseFloat(sizeLabel+"")/100).toFixed(2)*100).toFixed(0)+"%";
        },
        //svg图像大小变化按钮
        sizeChangeBtn(type) {
            if (this.svgCtlObj != null) {
                this.svgCtlObj.sizeChange(type);
                this.sizeLabel = this.svgCtlObj.getSizeLabel();
            }
        },

        _initTreeCtlTimer(){
            //初始化树控件
            if(window.d3!=null){
                this.loadD3Flag=true;
            }
            //如果d3 还没加载完成 则异步请求一次 再进行执行操作
            if(this.loadD3Flag){
                if(this.data!=null){
                    this.initTreeCtl();
                }
            }else{
                //异步加载d3js文件 为了提高性能
                let queryCommand = new QueryCommand(window.SysConfigUtils.go_eplat_adress+`/static/plugin/d3.min.js`);
                //js加载完成后再执行 初始化单位组织图
                queryCommand.getScriptQuery(() => {
                    this.loadD3Flag = true;
                    if(this.data!=null){
                        this.initTreeCtl();
                    }
                });
            }
        }
    },
    mounted() {
        this.$nextTick(()=>{
            this._initTreeCtlTimer();
        });
    },
    components: {}
};



// WEBPACK FOOTER //
// ./goingsrc/vueCom/ctlMixins/D3TreeMixins.js